// notificationSlice.js
import { AlertColor } from "@mui/material";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface ActionButton {
  label: string;
  onClick: () => void;
}

interface NotificationState {
  message: {
    content: string;
    type: AlertColor;
    isLoading?: boolean;
    action?: ActionButton;
  } | null;
}

const initialState: NotificationState = {
  message: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<NotificationState["message"]>) => {
      state.message = action.payload;
    },
  },
});

export const { setMessage } = notificationSlice.actions;
export default notificationSlice.reducer;
